import { useRef, useState, useEffect } from "react";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import PerfectScrollbar from "react-perfect-scrollbar";
import BootstrapTable from "react-bootstrap-table-next";
import { utils, writeFileXLSX } from "xlsx";

import { makeStyles } from "@material-ui/core/styles";
import {
  LinearProgress,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";

// @material-ui/icons components
import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  KeyboardBackspace as KeyboardBackspaceIcon,
} from "@material-ui/icons";

import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";

import { columnTextField } from "utils/tables-utils";

const exportIconStyle = {
  width: 25,
  height: 25,
};

const columnModel = [
  columnTextField(
    {
      dataField: "Sistema",
      text: "Sistema",
    },
    false
  ),
];

const modelTableItemDetail = [
  columnTextField(
    {
      dataField: "NomeUsuario",
      text: "Usuário",
    },
    false
  ),
  columnTextField(
    {
      dataField: "DataUltimoAcessoFormat",
      text: "Data último acesso",
      align: "center",
    },
    true
  ),
  columnTextField(
    {
      dataField: "Tela",
      text: "Tela",
    },
    false
  ),
  columnTextField(
    {
      dataField: "Sistema",
      text: "Sistema",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "QuantidadeAcesso",
      text: "Quantidade de acesso",
      align: "center",
    },
    false
  ),
];

const modelTableItemAccess = [
  columnTextField(
    {
      dataField: "acesso",
      text: "Detalhes de Acesso",
    },
    false
  ),
];

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function DialogAccessLogsScreen({ open, data, handleClose }) {
  const classes = useStyles();
  const contentRef = useRef(null);
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const [searching, setSearching] = useState(false);
  const [screenDetails, setScreenDetails] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [dataExport, setDataExport] = useState([]);

  const handleGetScreenDetail = async () => {
    setSearching(true);
    setScreenDetails([]);

    await Api.get(
      "log-api-detail-screen",
      "log",
      "?tela=" + data?.Tela + "&sistema=" + data?.Sistema,
      true
    )
      .then(({ Success, Result }) => {
        if (Success && Result?.length !== 0) {
          const listItens = [];
          let newObject = {};
          const listExport = [];
          let objectExport = {};
          const listAccess = [];
          let newObjectAccess = {};

          Result?.map((item) => {
            item?.UsuarioAcesso?.map((access) => {
              newObjectAccess = {
                Acessos: access?.Acessos,
                DataUltimoAcessoFormat: access?.DataUltimoAcessoFormat,
                NomeUsuario: access?.NomeUsuario,
                QuantidadeAcesso: access?.QuantidadeAcesso,
                Sistema: access?.Sistema,
                Tela: access?.Tela,
                IdAccess:
                  Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
              };
              listAccess?.push(newObjectAccess);

              objectExport = {
                DataUltimoAcessoFormat: access?.DataUltimoAcessoFormat,
                NomeUsuario: access?.NomeUsuario,
                QuantidadeAcesso: access?.QuantidadeAcesso,
                Sistema: access?.Sistema,
                Tela: access?.Tela,
              };
              listExport?.push(objectExport);
            });

            newObject = {
              Id: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
              Sistema: item?.Sistema,
              UsuarioAcesso: listAccess,
            };

            listItens?.push(newObject);
          });
          setScreenDetails(listItens);
          setDataExport(listExport);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint log-api-detail-screen - ${error}`,
        });
      })
      .finally(() => setSearching(false));
  };

  const expandRow = {
    renderer: (row) => {
      const listItens = [];
      let newObject = {};

      if (row?.Acessos?.length !== 0) {
        row?.Acessos?.map((item, index) => {
          newObject = {
            acesso: item,
            idItem: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
          };
          listItens?.push(newObject);
        });
      }

      return (
        <Grid item xs={12}>
          <ToolkitProvider
            data={listItens}
            keyField={"idItem"}
            columns={modelTableItemAccess}
          >
            {(props) => (
              <PerfectScrollbar>
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  condensed={true}
                  striped={true}
                  hover={true}
                  style={{ overflow: "auto!important" }}
                />
              </PerfectScrollbar>
            )}
          </ToolkitProvider>
        </Grid>
      );
    },
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandHeaderColumnRenderer: () => (
      <div
        style={{ cursor: "none" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {" "}
      </div>
    ),
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ExpandLessIcon />;
      }
      return <ExpandMoreIcon />;
    },
  };

  function handleDownloadXML() {
    const details = utils.json_to_sheet(dataExport);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, details, "Acesso de Tela");
    writeFileXLSX(wb, "AcessosTela.xlsx");
  }

  useEffect(() => {
    if (data) {
      handleGetScreenDetail();
    }
  }, [data]);

  return (
    <Dialog open={Boolean(open)} onClose={handleClose} maxWidth="lg">
      <DialogTitle disableTypography id="alert-dialog-title">
        <Typography variant="h2" component="h2">
          Informações de Acesso
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent ref={contentRef} style={{ padding: "0 1.5rem 1.5rem" }}>
        <Grid container>
          <Grid item xs={12} hidden={screenDetails?.length === 0}>
            {selectedRow?.length !== 0 ? (
              <Grid
                container
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    justifyContent: "space-between",
                  }}
                >
                  <div onClick={() => setSelectedRow([])}>
                    <KeyboardBackspaceIcon style={{ marginRight: "0.25rem" }} />
                    VOLTAR
                  </div>

                  <span hidden={selectedRow?.length === 0}>
                    <Tooltip title="Exportar tudo">
                      <IconButtonLoader
                        onClick={() => handleDownloadXML()}
                        icon={
                          <img
                            src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                            alt="ícone clicável para exportar a tabela no formato Excel"
                            style={exportIconStyle}
                          />
                        }
                        size="small"
                      />
                    </Tooltip>
                  </span>
                </Grid>
                <ToolkitTable
                  searched={Boolean(selectedRow)}
                  keyField="IdAccess"
                  dataTable={selectedRow}
                  columnModel={modelTableItemDetail}
                  bootstrapTableProps={{ expandRow }}
                  pagination={{
                    options: [10, 25, 50, 100],
                    defaultOption: 10,
                  }}
                  notFoundTitle="Sua pesquisa não encontrou nenhuma informação de acesso."
                />
              </Grid>
            ) : (
              <ToolkitTable
                searched={Boolean(screenDetails)}
                keyField="Id"
                dataTable={screenDetails}
                columnModel={columnModel}
                onRowClick={(_, row) => setSelectedRow(row?.UsuarioAcesso)}
                pagination={{
                  options: [10, 25, 50, 100],
                  defaultOption: 10,
                }}
                notFoundTitle="Sua pesquisa não encontrou nenhuma informação de acesso."
              />
            )}
          </Grid>
        </Grid>
        {searching && (
          <div>
            <span>Buscando informações...</span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export { DialogAccessLogsScreen };
